import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'semantic-ui-react'
import { toCurrency } from '../../../../config/constants'
import { RenderProjectListCard } from './UiUtils';


class CustomHits extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    

    componentDidMount() {
        //console.log("csxt1:mainCardObjects" + this.props.mainCardObjects.length);
    }


    render() {
        const hitsUI = this.props.hits.map(hit =>
            // <RenderProjectListRow  project={hit} />
            // target='_blank'
            <Table.Row>
                <Table.Cell> {hit.idlargeprojects} </Table.Cell>
                <Table.Cell> {hit.name} </Table.Cell>
                <Table.Cell> {hit.largeprojectcustomer.customername} </Table.Cell>
                <Table.Cell> {hit.datecreated} </Table.Cell>
                <Table.Cell> {toCurrency(hit.totalpayment)} </Table.Cell>
                <Table.Cell> <Link to={'/dashboard/viewLargeProject/' + hit.idlargeprojects} target="_blank">EDIT</Link></Table.Cell>
                <Table.Cell> {hit.paymentstatus}</Table.Cell>
                <Table.Cell> {hit.orderdelivered}</Table.Cell>
                <Table.Cell> {hit.salesperson.name}</Table.Cell>
                <Table.Cell> {hit.archived}</Table.Cell>

            </Table.Row>

        )

        const projectsTableUI = !this.props.platform 
        ? <Table celled>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Id</Table.HeaderCell>
                    <Table.HeaderCell>Project</Table.HeaderCell>
                    <Table.HeaderCell>Customer</Table.HeaderCell>
                    <Table.HeaderCell>Date Created</Table.HeaderCell>
                    <Table.HeaderCell>Total Cost</Table.HeaderCell>
                    <Table.HeaderCell>EDIT</Table.HeaderCell>
                    <Table.HeaderCell>PAID</Table.HeaderCell>
                    <Table.HeaderCell>DELVRD</Table.HeaderCell>
                    <Table.HeaderCell>SALES PERSON</Table.HeaderCell>
                    <Table.HeaderCell>ARCHIVED</Table.HeaderCell>

                </Table.Row>
            </Table.Header>

            <Table.Body>
                {hitsUI}
            </Table.Body>
        </Table>
        :''

        const hitsCardUI = this.props.platform == 'mobile' 
        ? this.props.hits.map(hit =>
            <RenderProjectListCard project={hit} />
        )
        :''

        return <div >
            <h2>PROJECTS - {this.props.platform}</h2>

            {projectsTableUI}
            {hitsCardUI}

        </div>
    }
}

//const ConnectedCustomHit = connectHits(CustomHits);
//export default connectHits(CustomHits);
export default CustomHits;

//export const chits = connectHits(CustomHits);


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/ProjectsCustomHits.js